module.exports = __webpack_public_path__ + "static/media/shira.4f96622f.png";